import { TechnologyCategory } from '../types';
import { 
  SiNodedotjs, 
  SiNestjs, 
  SiPython, 
  SiSpringboot, 
  SiGo,
  SiPostgresql, 
  SiRedis, 
  SiElasticsearch, 
  SiMongodb,
  SiApacheairflow
} from 'react-icons/si';
import { FaRobot, FaDatabase } from 'react-icons/fa';

export const technologyCategories: TechnologyCategory[] = [
  {
    id: 'backend',
    name: 'Backend & APIs',
    description: 'Server-side technologies and API development',
    technologies: [
      {
        name: 'Node.js',
        icon: SiNodedotjs,
        level: 3,
        category: 'backend',
        description: 'JavaScript runtime for scalable server-side applications'
      },
      {
        name: 'NestJS',
        icon: SiNestjs,
        level: 3,
        category: 'backend',
        description: 'Progressive Node.js framework for building efficient APIs'
      },
      {
        name: 'Python',
        icon: SiPython,
        level: 3,
        category: 'backend',
        description: 'Versatile language for backend development and data processing'
      },
      {
        name: 'Spring Boot',
        icon: SiSpringboot,
        level: 4,
        category: 'backend',
        description: 'Java framework for building production-ready applications'
      },
      {
        name: 'Golang',
        icon: SiGo,
        level: 4,
        category: 'backend',
        description: 'High-performance language for concurrent applications'
      }
    ]
  },
  {
    id: 'database',
    name: 'Databases',
    description: 'Data storage and management systems',
    technologies: [
      {
        name: 'PostgreSQL',
        icon: SiPostgresql,
        level: 3,
        category: 'database',
        description: 'Advanced relational database with powerful features'
      },
      {
        name: 'Redis',
        icon: SiRedis,
        level: 3,
        category: 'database',
        description: 'In-memory data structure store for caching and sessions'
      },
      {
        name: 'Elasticsearch',
        icon: SiElasticsearch,
        level: 2,
        category: 'database',
        description: 'Distributed search and analytics engine'
      },
      {
        name: 'MongoDB',
        icon: SiMongodb,
        level: 2,
        category: 'database',
        description: 'Document-oriented NoSQL database'
      }
    ]
  },
  {
    id: 'data',
    name: 'Data & Analytics',
    description: 'Data processing and analytics tools',
    technologies: [
      {
        name: 'BigQuery',
        icon: FaDatabase,
        level: 3,
        category: 'data',
        description: 'Google Cloud data warehouse for analytics'
      },
      {
        name: 'Apache Airflow',
        icon: SiApacheairflow,
        level: 3,
        category: 'data',
        description: 'Platform for developing and monitoring workflows'
      },
      {
        name: 'AI & Machine Learning',
        icon: FaRobot,
        level: 2,
        category: 'data',
        description: 'Exploring artificial intelligence and ML frameworks'
      }
    ]
  }
];

// Helper functions for working with technology data
export const getAllTechnologies = () => {
  return technologyCategories.flatMap(category => category.technologies);
};

export const getTechnologiesByCategory = (categoryId: string) => {
  const category = technologyCategories.find(cat => cat.id === categoryId);
  return category ? category.technologies : [];
};

export const getTechnologyByName = (name: string) => {
  return getAllTechnologies().find(tech => tech.name === name);
};

export const getTechnologiesByLevel = (level: 1 | 2 | 3 | 4) => {
  return getAllTechnologies().filter(tech => tech.level === level);
}; 